import { PURPOSE_OF_WELL_FIELDS } from "../formConfigs/newWellRegistrationFormConfig";
import { PURPOSE_OF_EXEMPT_WELL_FIELDS } from "../formConfigs/existingWellRegistrationFormConfig";
import {
  TYPE_OF_CONNECTION_FIELDS,
  CONNECTION_ROLE_FIELDS,
} from "../formConfigs/newWaterServiceConnectionFormConfig";

export const BASE_PATH = "/dynamic-forms";

export const USE_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  keepPreviousData: true,
};

export const USE_QUERY_CACHE_OPTIONS = {
  cacheTime: Infinity,
  staleTime: Infinity,
};

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const EXCLUSIVE_CHECKBOX_GROUPS = {
  purposeOfWell: PURPOSE_OF_WELL_FIELDS,
  purposeOfExemptWell: PURPOSE_OF_EXEMPT_WELL_FIELDS,
  typeOfConnection: TYPE_OF_CONNECTION_FIELDS,
  connectionRole: CONNECTION_ROLE_FIELDS,
};
